const SUPPORTED_LOCALES = [
    'en', 'de', 'fr', 'es', 'pt', 'it', 'nl', 'ro', 'pl',
    'cs', 'sk', 'hu', 'el', 'bg', 'hr', 'sr', 'sl',
    'da', 'sv', 'no', 'fi', 'lt', 'lv', 'et', 'tr', 'uk',
    'zh', 'ja', 'ar'
];

export function flattenMessages(nestedMessages, prefix = '') {
    return Object.keys(nestedMessages).reduce((messages, key) => {
        let value = nestedMessages[key];
        let prefixedKey = prefix ? `${prefix}.${key}` : key;

        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
}

export function getSupportedLocales() {
    return SUPPORTED_LOCALES;
}

export function getLocaleDisplayName(code) {
    const names = {
        en: 'English',
        de: 'Deutsch',
        fr: 'Français',
        es: 'Español',
        pt: 'Português',
        it: 'Italiano',
        nl: 'Nederlands',
        ro: 'Română',
        pl: 'Polski',
        cs: 'Čeština',
        sk: 'Slovenčina',
        hu: 'Magyar',
        el: 'Ελληνικά',
        bg: 'Български',
        hr: 'Hrvatski',
        sr: 'Srpski',
        sl: 'Slovenščina',
        da: 'Dansk',
        sv: 'Svenska',
        no: 'Norsk',
        fi: 'Suomi',
        lt: 'Lietuvių',
        lv: 'Latviešu',
        et: 'Eesti',
        tr: 'Türkçe',
        uk: 'Українська',
        zh: '中文',
        ja: '日本語',
        ar: 'العربية',
    };
    return names[code] || code;
}

export function resolveLocale(detectedLanguage, manualOverride) {
    if (manualOverride && SUPPORTED_LOCALES.indexOf(manualOverride) !== -1) {
        return manualOverride;
    }

    if (!detectedLanguage) return 'en';

    let lang = detectedLanguage.split(';')[0];
    if (lang.indexOf(',') !== -1) {
        lang = lang.split(',')[0];
    }
    if (lang.indexOf('-') !== -1) {
        lang = lang.substring(0, lang.indexOf('-'));
    }
    if (lang.indexOf('_') !== -1) {
        lang = lang.substring(0, lang.indexOf('_'));
    }

    lang = lang.toLowerCase().trim();

    if (SUPPORTED_LOCALES.indexOf(lang) !== -1) {
        return lang;
    }

    return 'en';
}

export function getLocale(detectedLanguage) {
    let manualOverride = null;
    if (typeof localStorage !== 'undefined') {
        manualOverride = localStorage.getItem('invoicebrowse_locale');
    }
    return resolveLocale(detectedLanguage, manualOverride);
}

export function getLanguageMessages(cat, detectedLanguage) {
    const locale = getLocale(detectedLanguage);
    return cat[locale] || cat.en;
}



// WEBPACK FOOTER //
// app/intl/helpers.js